import { parseRehubCurrency, type SketchplanCurrency, type SketchplanPropertyType } from '@rehub/pricing';

/** Entry routes used by marketing CTAs: /order, /login, and ?start= / ?type= / ?currency=. */
export const SKETCHPLAN_ORDER_PATH = '/order';
export const SKETCHPLAN_LOGIN_PATH = '/login';

export function parsePropertyTypeParam(value: string | null | undefined): SketchplanPropertyType | null {
  if (value === 'residential' || value === 'commercial') return value;
  return null;
}

/** GBP, EUR or USD from the URL. Invalid values are ignored so detection/default still apply. */
export function parseCurrencyParam(value: string | null | undefined): SketchplanCurrency | null {
  return parseRehubCurrency(value);
}

export function parseSketchplanEntry(
  location: Pick<Location, 'pathname' | 'search'> = window.location,
): {
  path: string;
  openOrder: boolean;
  openLogin: boolean;
  propertyType: SketchplanPropertyType | null;
  currency: SketchplanCurrency | null;
} {
  const path = location.pathname.replace(/\/+$/, '') || '/';
  const params = new URLSearchParams(location.search);
  const start = (params.get('start') || '').toLowerCase();
  const propertyType = parsePropertyTypeParam(params.get('type'));
  const currency = parseCurrencyParam(params.get('currency'));
  return {
    path,
    openOrder: path === SKETCHPLAN_ORDER_PATH || start === 'order',
    openLogin: path === SKETCHPLAN_LOGIN_PATH || start === 'login',
    propertyType,
    currency,
  };
}

export function orderPath(
  type?: SketchplanPropertyType | null,
  currency?: SketchplanCurrency | null,
): string {
  const params = new URLSearchParams();
  if (type) params.set('type', type);
  if (currency) params.set('currency', currency);
  const qs = params.toString();
  return qs ? `${SKETCHPLAN_ORDER_PATH}?${qs}` : SKETCHPLAN_ORDER_PATH;
}
